import CustomerReviews from "./CustomerReviews"
import GoogleReviews from "./GoogleReviews"
import TabBar from "@/components/TabBar"
import { useEffect, useState } from "react"
import styles from '@/styles/productDetail/productReviews.module.scss'


export default function ProductReviews(props: any) {
  const tabList = [
    { id: 1, name: 'Customer Reviews' },
    { id: 2, name: '0 stars with 0+ reviews' }
  ]
  const [tabBar, setTabBar] = useState(tabList)

  // activeTab 0: customer 1：google
  const [activeTab, setActiveTab] = useState(1)
  const handleTabChange = (index: number) => {
    setActiveTab(index)
  }

  useEffect(() => {
    // 有评论自动切换回customer review
    const { review } = props
    if (review && review.total > 0) {
      setActiveTab(0)
    }
  }, [])

  return (
    <div className={styles['product-reviews']} id="product-reviews">
      <div>
        <TabBar
          tabList={tabBar}
          activeTab={activeTab}
          onTabChange={handleTabChange}
        />
        {
          activeTab === 0
            ?
            <CustomerReviews productID={props.productID} />
            :
            <GoogleReviews productID={props.productID} changeTabBar={setTabBar} />
        }
      </div>
    </div>
  )
}